export default __webpack_public_path__ + "static/media/popup_1.7741da08.jpeg";